import React, { useState, useEffect } from 'react';
import Icon from '@/components/Icon';
import { unionFlag, getSessonStorage, getQueryString, checkUnifyShop } from '@/utils';
import { Drawer } from 'antd-mobile';
import { withRouter } from 'umi';
import { connect } from 'dva';
import lifeMenu from './menuConfig';
import homeReq from '@/entity/module/home/homeAPi';

import { BFD_checkApp } from '@/utils/bfdApp';
import { checkXcx } from '@/utils/checkXcx';
import { getCookie, TLang } from '@/utils/lang';
import { getCityPinyin } from '@/utils/other';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { message } from 'antd';
const styles = require('./index.less');
const logo = require('@/assets/imgs/logo@3x.png');

const service = require('@/assets/imgs/headicon/service@3x.png');
const search = require('@/assets/imgs/headicon/search@2x.png');
const headMenu = require('@/assets/imgs/headicon/hbb@2x.png');
const backHome = require('@/assets/imgs/headicon/backHome.png');
import { SecondLevelHeader, SecondLevelHeaderPlaceholder } from '@df-mobile/second-level-header';
import { gioClick } from '@/utils/gioApi';
import { safeJsonParse } from '@/utils/safeJsonParse';

const NavIndex = (props) => {
  const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
  const { dispatch, unionConfig, menus, currentAddress, showMenu, visable } = props;
  // console.log('visable',visable)
  // const [showCityModal, setShowCityModal] = useState(false);
  // const [showMenu, setShowMenu] = useState(false);
  const [menuList, setMenuList] = useState([]);
  const [isUnion, setIsUnion] = useState(false);
  const changeCity = () => {
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部功能', elementname: '定位' });
    // window.df_sdk_common.location.href = `/bfd-pagesite/citylist?allowback=true&returnurl=${encodeURIComponent(
    //   window.df_sdk_common.location.href,
    // )}`;
    // setShowCityModal(!showCityModal);
    dispatch && dispatch({
      type: 'initData/setShowAddrPage',
      payload: true
    });

  };
  const cityPinyin = localAddress && localAddress?.cityNameValue ? localAddress?.cityNameValue : getCookie('address') && JSON.parse(getCookie('address')).pinyin;
  const df_lang = getCookie('df_lang');


  useEffect(() => {
    const union = unionFlag() || getSessonStorage('dffl_union') || getQueryString('union');
    if (union && typeof union !== 'undefined') {
      // debugger;
      setIsUnion(true);
    }
  }, []);

  /**
 * 汉堡包配置
 * @param { number } switch // 开关 0关闭 1打开
 * @return { boolean }   // 是否需要在百福得小程序隐藏汉堡包环境
 */
  const isShowBfdMenuMiniprogram = (swithFlag: any) => {
    const union = unionFlag() || getSessonStorage('dffl_union') || getQueryString('union');
    const flag = union && swithFlag && isXcx;
    return flag;
  };

  const clickSearch = () => {
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部功能', elementname: '搜索' });
    let ms_url = '//'
      + window.location.host.replace('corp.', '').replace('.test05', '-test05').replace('.stage', '-stage')
      + '/ms/?city='
      + (localAddress?.cityId || currentAddress?.cityId)
      + '&return_url='
      + encodeURIComponent(window.location.href);
    const union = unionFlag() || getSessonStorage('dffl_union') || getQueryString('union');
    if (union) {
      ms_url = ms_url + '&union=' + union;
    }
    window.df_sdk_common.location.href = ms_url;
  };

  const clickService = () => {
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '联系客服', elementname: '联系客服' });
    // eslint-disable-next-line
    window?.qimoChatClick()
  };

  const isApp = BFD_checkApp();
  // const isXcx = checkXcx();
  const union = unionFlag() || getSessonStorage('dffl_union') || getQueryString('union');
  // TODO: 根据浙商union判断是否展示，浙商小程序添加汉堡包按钮
  const _window: any = window;
  const isXcx = checkXcx() && union !== 'ejyshop';

  useEffect(() => {
    if (window.location.pathname == '/newmovie' || window.location.pathname == '/newmovie/') {
      // 曝光顶部导航埋点
      // 汉堡包
      if (isApp === false && (!isXcx || isShowBfdMenuMiniprogram(unionConfig?.hamburgerSwitch))) {
        try {
          gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部功能', elementname: '汉堡包' }, 'DF_exposureEvent',);
        } catch (err) {
          console.log(`曝光事件, error:${err}`);
        }
      }
      // 搜索
      try {
        gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部功能', elementname: '搜索' }, 'DF_exposureEvent',);
      } catch (err) {
        console.log(`曝光事件, error:${err}`);
      }
      // 定位
      try {
        gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部功能', elementname: '定位' }, 'DF_exposureEvent',);
      } catch (err) {
        console.log(`曝光事件, error:${err}`);
      }
      // 客服
      try {
        gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '联系客服', elementname: '联系客服' }, 'DF_exposureEvent',);
      } catch (err) {
        console.log(`曝光事件, error:${err}`);
      }
    }
  }, []);

  const clickMenu = () => {
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部功能', elementname: '汉堡包' });
    try {
      const _win: any = window;
      const union = unionFlag() || sessionStorage.getItem('dffl_union');
      if (union || checkUnifyShop()) {
        homeReq.getMenuList()?.then((res) => {
          if (res?.menuItems?.mallChannelList) {
            const unionMenus = res?.menuItems?.mallChannelList?.map((item) => ({
              label: item.name,
              key: item.code.toLocaleLowerCase(),
              url: item.url,
              icon: item.h5ImagePath || ''
            }));
            const bfdMenus = [
              {
                key: 'home',
                label: TLang('商城首页', 'home', false, false, null),
                icon: '',
                url: menus.h5HomeIndex
              }, {
                key: 'center',
                label: TLang('个人中心', 'home', false, false, null),
                icon: '',
                url: menus.h5UserCenter
              }
            ];
            _win.createMenu(bfdMenus, unionMenus);
          }
        });

      } else {
        const _menus = _win.loadMenus('', false);
        _win.createMenu(_menus.mainMenus, _menus.menus);
      }
    } catch (e) {
      message.info('页面正在初始化中');
    }

    // if (menus.menuItems <= 0 && isUnion) {
    //   // 抽屉menu
    //   homeReq.getMenuList()?.then((res) => {
    //     dispatch && dispatch({
    //       type: 'initData/setMenus',
    //       payload: res
    //     });
    //     setMenuList(res?.menuItems);
    //     dispatch && dispatch({
    //       type: 'initData/setShowMenu',
    //       payload: !showMenu
    //     });
    //   });
    // } else {
    //   dispatch && dispatch({
    //     type: 'initData/setShowMenu',
    //     payload: !showMenu
    //   });
    // }
  };

  const goToPage = (urlOrType: 'home' | 'center' | 'shopping' | string) => {
    const params = `city=${currentAddress.cityId}`;
    let url = '';
    switch (urlOrType) {
      case 'home':
        url = menus.h5HomeIndex;
        break;
      case 'center':
        url = menus.h5UserCenter;
        break;
      case 'shopping':
        url = menus.h5ShoppingCart;
        break;
      default:
        url = urlOrType;
        break;
    }
    console.log('goToPage', url, params);
    window.df_sdk_common.location.href = url.indexOf('?') > -1 ? `${url}&${params}` : `${url}?${params}`;
  };

  const renderMenus = () => {
    if ((isUnion || checkUnifyShop()) && Array.isArray(menuList)) {
      // console.log('union', menuList);
      return menuList.map((item: any, index: number) =>
        <div className={styles.menuItem} key={index}>
          {/* eslint-disable-next-line no-restricted-properties */}
          <Icon type={window.isNaN(item.code) ? item.code.toLocaleLowerCase() : 'default'} symbel size="md" />
          <a href={item.h5Url.replace('crop.', '')}>
            <span>{TLang(item.name, 'drawer', false, false, null)}</span>
          </a>
        </div>);
    } else {
      return lifeMenu.map((item: any, index: number) => item.isShow !== undefined && item.isShow === 0 ?
        <div key={index} className={styles.menuItem} onClick={(e) => goToPage(item.url)}>
          <div>
            <Icon type={item.icon ? item.icon : item.code} symbel size="md" />
          </div>
          <div>
            {TLang(item.name, 'home', false, false, null)}
          </div>
        </div> : null);
    }
  };

  const renderMenuHtml = () => {
    const sidebar = <>
      <div className={styles.drawerCloseIcon} onClick={clickMenu}>
        <Icon type="pdp_popup_close" size="md"></Icon>
      </div>
      <div className={styles.menuTransverse}>
        <div onClick={(e) => goToPage('home')}>
          <div className={styles.iconwrapper}>
            <Icon type="home" size="lg" symbel />
          </div>
          {TLang('商城首页', 'home', false, false, null)}
        </div>
        <div onClick={(e) => goToPage('center')}>
          <div className={styles.iconwrapper}>
            <Icon type="user_center" size="lg" symbel />
          </div>
          {TLang('我的', 'home', false, false, null)}
        </div>
        <div onClick={(e) => goToPage('shopping')}>
          <div className={styles.iconwrapper}>
            <Icon type="shopping_cart" size="lg" symbel />
          </div>
          {TLang('购物车', 'home', false, false, null)}
        </div>
      </div>
      <div className={styles.menus}>
        {
          renderMenus()
        }
      </div>
    </>;
    return sidebar;
  };

  const goBfdHome = () => {
    if (unionConfig?.homePageUrl || unionConfig?.h5HomeIndex) {
      let homeUrl = unionConfig?.homePageUrl || unionConfig?.h5HomeIndex;
      window.df_sdk_common.location.href = homeUrl;
    }
  };

  const getLogoImg = () => {
    if (isUnion || checkUnifyShop()) {
      if (!unionConfig || !unionConfig?.logo) {
        return '';
      } else {
        return unionConfig?.logo;
      }
    } else {
      return logo;
    }
  };

  //Drawer 去掉 zIndex:800
  if (window.location.pathname == '/newmovie' || window.location.pathname == '/newmovie/') {
    return <>
      <SecondLevelHeader
        placeholder
        //不用unionConfig?.showHomePage
        onHome={true ? () => {
          goBfdHome();
        } : undefined}
        onChangeCity={() => {
          changeCity();
        }}
        onSearch={() => {
          clickSearch();
        }}
        onService={() => {
          clickService();
        }}
        onHamburger={(isApp === false && (!isXcx || isShowBfdMenuMiniprogram(unionConfig?.hamburgerSwitch))) ? () => { clickMenu(); } : undefined}
        city={{
          name: df_lang && df_lang == 'en-US' ? (getCityPinyin(currentAddress?.name || currentAddress?.cityName) || cityPinyin) : currentAddress?.name || currentAddress?.cityName
        }}
      />
      {props.children}
    </>;
  }

  return (<>
    <SecondLevelHeaderPlaceholder></SecondLevelHeaderPlaceholder>
    <Drawer
      className={styles['my-drawer']}
      style={{ minHeight: visable === 'visible' ? document.documentElement.clientHeight : '0px', height: '100vh' }}
      sidebarStyle={{ border: '1px solid #ddd', backgroundColor: '#fff', width: '66%' }}
      sidebar={renderMenuHtml()}
      onOpenChange={clickMenu}
    // open={showMenu}
    >
      <div className={`${styles.navIndex} navBarContainer`} style={{ 'visibility': visable }}>
        <div className={styles.leftArea}>
          {/* 去除unionConfig?.showHomePage */}
          {true && isApp === false && <div className={styles.homeBack} onClick={goBfdHome}>
            <svg t="1678361832978" className={styles['icon-df']} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13355" width="100%"><path d="M213.333333 938.666667a85.333333 85.333333 0 0 1-85.333333-85.333334v-365.696a85.333333 85.333333 0 0 1 26.453333-61.824l298.666667-284.416a85.333333 85.333333 0 0 1 117.76 0l298.666667 284.416A85.333333 85.333333 0 0 1 896 487.68V853.333333a85.333333 85.333333 0 0 1-85.333333 85.333334H213.333333z m287.232-753.493334l-3.285333 2.56-298.666667 284.458667a21.333333 21.333333 0 0 0-6.314666 11.946667l-0.298667 3.498666V853.333333a21.333333 21.333333 0 0 0 17.493333 20.992L213.333333 874.666667h170.666667V682.666667a85.333333 85.333333 0 0 1 85.333333-85.333334h85.333334a85.333333 85.333333 0 0 1 85.333333 85.333334v192h170.666667a21.333333 21.333333 0 0 0 20.992-17.493334L832 853.333333v-365.696a21.333333 21.333333 0 0 0-4.309333-12.885333l-2.304-2.56-298.666667-284.458667a21.333333 21.333333 0 0 0-26.154667-2.56zM554.666667 661.333333h-85.333334a21.333333 21.333333 0 0 0-20.992 17.493334L448 682.666667v192h128V682.666667a21.333333 21.333333 0 0 0-17.493333-20.992L554.666667 661.333333z" p-id="2436"></path></svg>
          </div>}
          <div className={styles.logoImg}>
            {getLogoImg() && <img src={getLogoImg()}></img>}
          </div>
          <div className={styles.city} onClick={changeCity}>
            {df_lang && df_lang == 'en-US' ? (
              <span>{getCityPinyin(currentAddress?.name || currentAddress?.cityName) || cityPinyin}{}</span>
            ) : (
              <span>{currentAddress?.name || currentAddress?.cityName}</span>
            )}

            <div className={styles.rotateDown} style={{ display: visable !== 'visible' ? 'none' : 'block' }}>
              <Icon key="1"
                type="order_selectdate_more"
                size="xxs"
                className={`${styles.iconDirection} `} //${showCityModal ? styles.iconDirectionActive : ''}
              />
            </div>
          </div>
        </div>
        <div className={styles.rightArea}>
          <div className={styles.iconImg} onClick={clickSearch}>
            <img src={search}></img>
          </div>
          <div className={styles.iconImg} onClick={clickService}>
            <img src={service}></img>
          </div>
          {
            (isApp === false && (!isXcx || isShowBfdMenuMiniprogram(unionConfig?.hamburgerSwitch))) ?
              <div className={styles.iconImg} onClick={clickMenu}>
                <img src={headMenu}></img>
              </div> : null
          }
        </div>
      </div>
      {props.children}
    </Drawer>
  </>);
};
const mapStateToProps = ({ initData }) => ({ ...initData });
export default withRouter(connect(mapStateToProps)(NavIndex));
